// tienda/CtaBanner.jsx
// Full-width magenta CTA banner above the footer.

import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { brand, WA_HREF } from "../shared/brand";

export function CtaBanner() {
  return (
    <section style={{ background: brand.primary }}>
      <div className="mx-auto max-w-7xl px-4 py-10 text-white text-center">
        <h3 className="text-xl md:text-2xl font-extrabold mb-2">
          Simplifica tu logística hoy
        </h3>
        <p className="text-white/80 text-sm mb-6">
          Únete a FAST MAX y enfócate en vender. Nosotros entregamos.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold text-slate-900"
            style={{ background: brand.accentGold }}
          >
            Crear cuenta gratis
            <ChevronRight className="size-4" />
          </Link>
          <a
            href={WA_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/30 px-5 py-3 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
          >
            Hablar con ventas
          </a>
        </div>
      </div>
    </section>
  );
}